import moment from "moment";
import React, { useContext, useMemo, useState } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";

type DashboardProviderProps = {
    children: React.ReactNode,
}

type DashboardContextData = {
    showClientAsideMenuBtn: boolean,
    setShowClientAsideMenuBtn: (showClientAsideMenuBtn: boolean) => void,
}

const DashboardContext: React.Context<DashboardContextData> = React.createContext<DashboardContextData>({
    showClientAsideMenuBtn: false,
    setShowClientAsideMenuBtn: (showClientAsideMenuBtn: boolean) => { },
});

const DashboardProvider: React.FC<DashboardProviderProps> = ({ children }) => {

    const [showClientAsideMenuBtn, setShowClientAsideMenuBtn] = useState<boolean>(false);

    const defaultFilterFilters = useMemo(() => ({
        from: moment().startOf('year').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
    }), []);

    return (
        <DashboardContext.Provider value={{
            showClientAsideMenuBtn,
            setShowClientAsideMenuBtn,
        }}>
            <FiltersProvider defaultFilterFilters={defaultFilterFilters}>
                {children}
            </FiltersProvider>
        </DashboardContext.Provider>
    );
}

export { DashboardContext, DashboardProvider };

export function useDashboardProvider() {
    return useContext(DashboardContext);
}